import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rejection-messages',
  templateUrl: './rejection-messages.component.html',
  styleUrls: ['./rejection-messages.component.css']
})
export class RejectionMessagesComponent {

  message: string = "";
  confirmButtonText = "Rechazar pedido";
  cancelButtonText = "Cancelar";
  rejectValue: string = "";

  rejectList = [
    'No tenemos más stock. Disculpas.',
    'No llegamos a esa dirección. Disculpas',
    'Estamos cerca del cierre. Disculpas'
  ]

  rejectForm: FormGroup = this.fb.group({
    rejectValue: ['', Validators.required]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<RejectionMessagesComponent>,
    private fb: FormBuilder
  ) {
    if (data)
      this.message = data.message || this.message;
  }

  onConfirmClick(): void {
    let response = String(this.rejectForm.controls['rejectValue'].value);
    this.dialogRef.close(response);
  }
}
